import { createNewLens } from '~src/app/actions/spaces/ContentExplorerCreateActions';
import { selectAvailableActionsForEntity } from '~src/app/selectors/EntityActionsSelectors';
import { SessionSiteSelectors, SessionUserSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { selectSpaceInfoItem } from '~src/app/selectors/SpaceInfoSelectors';
import { AppState } from '~src/app/state/AppState';
import {IDataSourceDetailInfo} from '~src/datasource/models/IDataSourceInfo';
import { IDatasourceActions } from '~src/datasource/ServerApi/types/IDatasourceActions';
import { AskDataMode } from '~src/settings/types/AskDataMode';
import { SpaceInfoItemTypeValue } from '~src/ts/models/ContentType';
import { ISpaceTypeInfo } from '~src/ts/models/resourceInfoParts';
import { SiteRolesUtil } from '~src/userManagement/services/resources/SiteRolesUtil';

import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IWebEditFlowAction } from '../../../../ts/ServerApi/types/actionNames';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const NewLensEntityAction: IEntityAction<IContentInfo<'datasource'>, IWebEditFlowAction> = {
  name: EntityActionNames.NewLens,
  translateName: Messages.newLens,
  isVisible: (targetItems: IContentInfo[], appState: AppState) => {
    return FeatureFlags.nlplensContentTypeEnabled &&
      !isSingleEmbeddedDatasource(targetItems) &&
      SessionSiteSelectors.askDataMode(appState) === AskDataMode.DISABLED_BY_DEFAULT;
  },
  isClickable: (availableActions: IWebEditFlowAction, targetItems: IContentInfo[], appState: AppState) => {
    const spaceItem: ISpaceTypeInfo = selectSpaceInfoItem(appState);
    if (spaceItem && spaceItem.contentType === SpaceInfoItemTypeValue.datasource) {
      const availableActionsForEntity: IDatasourceActions | undefined = selectAvailableActionsForEntity(appState, { contentType: SpaceInfoItemTypeValue.datasource, id: spaceItem.id }) as IDatasourceActions;
      return !!availableActionsForEntity &&
        availableActionsForEntity.launchWebAuthoring &&
        SiteRolesUtil.canPublish(SessionSiteSelectors.siteRole(appState));
    }
    return SessionUserSelectors.canAuthorOnWeb(appState);
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === SpaceInfoItemTypeValue.datasource) {
      const datasourceInfo = item as IDataSourceDetailInfo;
      if (datasourceInfo) {
        // After vizportalClient transits from idForFavoriting to id, we can always use datasourceInfo.id.
        // For now, in some code paths, datasourceInfo.idForFavoriting is the published datasource ID while
        // datasourceInfo.id isn't.
        const publishedDatasourceId = datasourceInfo.idForFavoriting || datasourceInfo.id;
        const projectId = datasourceInfo.project?.id;
        return createNewLens(projectId, parseInt(publishedDatasourceId));
      }

      return createNewLens();
    }
  }
};
